import { Box, Button, Card, CardContent, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { Fragment, useState } from 'react';
import Constant from '../../../../../Utils/Constant';
import Skeleton from 'react-loading-skeleton';
import AGGREMENTICON from '../../../../../Assets/Images/aggrementIcon.png';
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Swal from 'sweetalert2';
import { USER_INTERPRETER_LANGUAGE_COMMISION_ACTION } from '../../../../../Redux/Slices/UserSlice/User.action';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { NEW_LANGUAGE_APPROVE } from '../../../../../Redux/Slices/LanguageSlice/LanguageSlice.action';
import CustomRejectModel from '../../../../../Components/CustomRejectModel/CustomRejectModel';
import { useFormik } from 'formik';
import CustomSubmitButton from '../../../../../Components/CustomSubmitButton/CustomSubmitButton';
import AxiosInstance from '../../../../../Config/AxiosInstance';
import APILIST from '../../../../../Config/ApiList';
const IntrepreterBasicDetails = (props) => {
    const dispatch = useDispatch();
    const { interpreterDetails, handleSubmitAcceptReject, setIsLoading, isLoading } = props;
    const [userId, setUserId] = useState(null);
    const [showSelectedLanguageId, setShowSelectedLanguageId] = useState(null);
    const [showRejectModel, setShowRejectModel] = useState(false);
    const [language_status, setLanguage_Status] = useState(null);
    const [showLanguageModel, setShowLanguageModel] = useState(false);
    const [openCertificateDialog, setOpenCertificateDialog] = useState(false);
    const [selectedCertificates, setSelectedCertificates] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState(null);
    const handleOpenCertificateDialog = (certificates, languageData) => {
        setSelectedCertificates(certificates);
        setSelectedLanguage(languageData); // pass full language object (elem)
        setOpenCertificateDialog(true);
    };

    const handleCloseCertificateDialog = () => {
        setSelectedCertificates([]);
        setOpenCertificateDialog(false);
    };



    const [editLanguageDetails, setEditLanguageDetails] = useState(null);
    const handleInterPreterAccountStatusChange = async (userLanguageId, status) => {
        try {
            // First, verify we have the required data
            if (!interpreterDetails || !interpreterDetails.user_languages || interpreterDetails.user_languages.length === 0) {
                toast.error("No language data available");
                return;
            }

            // Find the specific language
            const selectedLanguage = interpreterDetails.user_languages.find(
                (elem) => elem?.id === userLanguageId
            );

            if (!selectedLanguage) {
                toast.error("Selected language not found");
                return;
            }

            Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to approve this request?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                reverseButtons: true,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setIsLoading(true);

                    try {
                        if (status === 1) {
                            const formData = new FormData();
                            const commissionData = [{
                                id: selectedLanguage.id,
                                commission: interpreterDetails?.is_premium === 1 ? 20 : 30
                            }];

                            formData.append("user_id", interpreterDetails.id);
                            formData.append("commission", JSON.stringify(commissionData));

                            // First set the commission
                            const res = await dispatch(
                                USER_INTERPRETER_LANGUAGE_COMMISION_ACTION(formData)
                            ).unwrap();

                            if (res?.s === 1) {
                                // Then approve the language
                                const approvalFormData = new FormData();
                                approvalFormData.append("user_id", interpreterDetails.id);
                                approvalFormData.append("user_language_id", userLanguageId);
                                approvalFormData.append("status", 1);
                                const approvalRes = await dispatch(
                                    NEW_LANGUAGE_APPROVE(approvalFormData)
                                ).unwrap();

                                if (approvalRes?.s === 1) {
                                    toast.success("Request Approved Successfully!");
                                    handleSubmitAcceptReject();
                                } else {
                                    toast.error(approvalRes?.m || "Approval failed");
                                }
                            } else {
                                toast.error(res?.m || "Commission update failed");
                            }
                        } else {
                            toast.error("Cannot approve interpreter without any languages");
                        }
                    } catch (error) {
                        console.error('Approval error:', error);
                        toast.error("An error occurred during approval");
                    } finally {
                        setIsLoading(false);
                    }
                }
            });
        } catch (error) {
            console.error('Initial error:', error);
            toast.error("An error occurred");
            setIsLoading(false);
        }
    };
    const handleInterPreterAccountRejectModel = (userId, language_status) => {
        if (userId) {
            setShowRejectModel(true);
            setUserId(userId);
            setLanguage_Status(language_status);
        }
    }
    const handleCloseRejectModel = () => {
        handleSubmitAcceptReject();
        setShowRejectModel(false);
        setUserId(null);
    }
    const handleLanguageCommissionModel = (data) => {
        console.log('data', data);

        if (data) {
            setShowLanguageModel(true);
            setEditLanguageDetails(data)
        }
    }
    const handleCertificateApproval = (certificateId, status) => {
        Swal.fire({
            title: 'Are you sure?',
            text: status === 1 ? 'Do you want to accept this certificated request?' : "Do you want to reject this certificated request?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                popup: 'custom-swal-popup'
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const formData = new FormData();
                    formData.append("certificate_id", certificateId);
                    formData.append("status", status);
                    const response = await AxiosInstance.post(`${APILIST.ADD_UPDATE_CERTIFICATE_REQUEST}/${certificateId}`, formData)
                    if (response?.data?.s === 1) {
                        toast.success(status === 1 ? "Certificate approved successfully!" : "Certificate rejected successfully!");
                        handleSubmitAcceptReject();
                        setOpenCertificateDialog(false);

                    } else {
                        toast.error(response?.data?.m || "Failed to update certificate status");
                    }
                } catch (error) {
                    console.error('Error:', error);
                    toast.error("Something went wrong. Please try again.");

                }
            }
        });
    };
    const handleDownloadCertificate = (certificatePath) => {
        const url = `${Constant.BASE_URL}${certificatePath}`;
        window.open(url, '_blank');
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            percentages: editLanguageDetails?.commission || ""
        },
        onSubmit: async (values, { resetForm }) => {
            setIsLoading(true)
            try {
                const formData = new FormData();
                const params = [{
                    id: editLanguageDetails?.id,
                    commission: parseFloat(values?.percentages) || 0
                }];
                formData.append("user_id", editLanguageDetails?.user_id);
                formData.append("commission", JSON.stringify(params));
                const res = await dispatch(USER_INTERPRETER_LANGUAGE_COMMISION_ACTION(formData)).unwrap();
                if (res && res?.s === 1) {
                    toast.success("Commission updated successfully!");
                    setShowLanguageModel(false);
                    setEditLanguageDetails(null);
                    handleSubmitAcceptReject();
                    setIsLoading(false);
                    resetForm();
                } else {
                    toast.error(res?.m);
                    setIsLoading(false);
                }
            } catch (error) {
                console.error('Error:', error);
                toast.error("Something went wrong. Please try again.");
                setIsLoading(false);
            }
        }
    });

    return (
        <Fragment>
            <Grid item xs={12} sm={7} md={7} lg={9}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12}>
                        <Box sx={{
                            width: '300px'
                        }}>
                            <Typography sx={{
                                color: "rgba(0, 151, 178, 1)",
                                fontSize: { xs: '18px', md: "22px" },
                                fontWeight: "500",
                                fontFamily: 'Outfit',
                                textAlign: 'left',
                                marginBottom: '10px'
                            }}>Govt ID</Typography>
                            {isLoading ? <Skeleton height={200} width={300} /> : <img src={interpreterDetails?.govt_certificate ? `${Constant.BASE_URL}${interpreterDetails?.govt_certificate}` : 'https://res.cloudinary.com/do0g7smfg/image/upload/v1711695885/cld-sample.jpg'} alt='goveId' style={{
                                width: '100%',
                                borderRadius: '15px',
                                height: '155px',
                                objectFit: 'cover',
                                objectPosition: 'top'
                            }} />}
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "rgba(0, 151, 178, 1)",
                                        fontSize: { xs: '18px', md: "22px" },
                                        fontWeight: "500",
                                        fontFamily: "Outfit",
                                    }}
                                >
                                    Language & Certification Details
                                </Typography>
                                <Box sx={{
                                    width: '100%',
                                    borderRadius: '5px',
                                    padding: '20px 10px'
                                }}>
                                    <Grid container spacing={2}>
                                        {interpreterDetails && interpreterDetails?.user_languages?.length > 0 ? interpreterDetails?.user_languages?.map((elem, index) => {
                                            return (
                                                <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
                                                    <Card sx={{
                                                        height: '100%',
                                                        background: "rgba(250, 250, 250, 1)",
                                                    }}>
                                                        <CardContent sx={{
                                                            borderRadius: '15px',
                                                            borderColor: "1px solid rgba(8, 85, 127, 0.2)"
                                                        }}>
                                                            {elem?.certificates?.length > 0 && (
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        alignItems: "center",
                                                                        gap: "10px",
                                                                        // mt: 1,
                                                                        // mb: 1,
                                                                    }}
                                                                >
                                                                    {elem?.certificates?.filter(cert => cert.status === 0).length > 0 && (
                                                                        <Chip
                                                                            label={`Pending Certificate: ${elem?.certificates?.filter(cert => cert.status === 0).length}`}
                                                                            color="warning"
                                                                            size="small"
                                                                            sx={{ fontWeight: 500 }}
                                                                        />
                                                                    )}
                                                                    {elem?.certificates?.filter(cert => cert.status === 1).length > 0 && (
                                                                        <Chip
                                                                            label={`Approved Certificate: ${elem?.certificates?.filter(cert => cert.status === 1).length}`}
                                                                            color="success"
                                                                            size="small"
                                                                            sx={{ fontWeight: 500 }}
                                                                        />
                                                                    )}
                                                                    {elem?.certificates?.filter(cert => cert.status === -1).length > 0 && (
                                                                        <Chip
                                                                            label={`Rejected Certificate: ${elem?.certificates?.filter(cert => cert.status === -1).length}`}
                                                                            color="error"
                                                                            size="small"
                                                                            sx={{ fontWeight: 500 }}
                                                                        />
                                                                    )}
                                                                </Box>
                                                            )}

                                                            <Box sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: 'space-between'
                                                            }}>
                                                                <Typography sx={{
                                                                    fontSize: '14px',
                                                                    fontWeight: '600',
                                                                    fontFamily: "Outfit",
                                                                    color: '#000'
                                                                }}>{elem?.language}</Typography>
                                                                {elem?.sign_lang === 1 && <Typography sx={{
                                                                    background: 'rgba(0, 151, 178, 0.2)',
                                                                    padding: '5px 10px',
                                                                    borderRadius: '20px',
                                                                    fontSize: '14px',
                                                                    fontWeight: '500',
                                                                    fontFamily: "Outfit",
                                                                    color: 'rgba(2, 56, 85, 1)'
                                                                }}>Sign Language</Typography>}
                                                            </Box>
                                                            <Typography sx={{
                                                                padding: '5px 0px',
                                                                fontSize: '14px',
                                                                fontWeight: '600',
                                                                fontFamily: "Outfit",
                                                            }}>Hourly Rate : {`$${elem?.hourly_rate}`}</Typography>
                                                            {elem?.commission > 0 && <Typography sx={{
                                                                padding: '0px 0px 4px 0px',
                                                                fontSize: '14px',
                                                                fontWeight: '600',
                                                                fontFamily: "Outfit",
                                                                color: "rgba(0, 151, 178, 1)",
                                                            }}>Admin Commission: {elem?.commission}%</Typography>}

                                                            {/* Certificates Section */}
                                                            {elem?.certificates?.length > 0 && (
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'flex-start',
                                                                        gridGap: '10px',
                                                                        flexWrap: 'wrap',
                                                                        marginBottom: '8px',
                                                                    }}
                                                                >
                                                                    {elem?.certificates?.length === 1 ? (
                                                                        <>
                                                                            <img
                                                                                src={`${Constant.BASE_URL}${elem?.certificates[0]?.certificate}`}
                                                                                alt="certificate"
                                                                                style={{
                                                                                    width: '50px',
                                                                                    height: '50px',
                                                                                    objectFit: 'cover',
                                                                                    borderRadius: '5px',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                                onClick={() => handleDownloadCertificate(elem?.certificates[0]?.certificate)}
                                                                            />
                                                                            {elem?.certificates[0]?.status == 0 && (
                                                                                <>
                                                                                    <Tooltip title="Approve Certificate">
                                                                                        <IconButton
                                                                                            sx={{
                                                                                                background: "#4caf50",
                                                                                                width: "30px",
                                                                                                height: "30px",
                                                                                                borderRadius: "4px",
                                                                                                "&:hover": { background: "#388e3c" },
                                                                                            }}
                                                                                            onClick={() => handleCertificateApproval(elem.certificates[0]?.id, 1)}
                                                                                        >
                                                                                            <CheckIcon sx={{ color: "#fff" }} />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                    <Tooltip title="Reject Certificate">
                                                                                        <IconButton
                                                                                            sx={{
                                                                                                background: "red",
                                                                                                "&:hover": { background: "#c62828" },
                                                                                                width: "30px",
                                                                                                height: "30px",
                                                                                                borderRadius: "4px",
                                                                                            }}
                                                                                            onClick={() => handleCertificateApproval(elem.certificates[0]?.id, -1)}
                                                                                        >
                                                                                            <CloseIcon sx={{ color: "#fff" }} />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {elem?.certificates && elem?.certificates?.map((cert) => (
                                                                                <img
                                                                                    key={cert.id}
                                                                                    src={`${Constant.BASE_URL}${cert.certificate}`}
                                                                                    alt="certificate"
                                                                                    style={{
                                                                                        width: '50px',
                                                                                        height: '50px',
                                                                                        objectFit: 'cover',
                                                                                        borderRadius: '5px',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                    onClick={() => handleDownloadCertificate(cert.certificate)}
                                                                                />

                                                                            ))}
                                                                            <Button
                                                                                variant="outlined"
                                                                                size="small"
                                                                                sx={{ fontSize: "12px", textTransform: "capitalize" }}
                                                                                onClick={() => handleOpenCertificateDialog(elem.certificates, elem)}
                                                                            >
                                                                                Manages Certificates
                                                                            </Button>
                                                                        </>
                                                                    )}
                                                                </Box>
                                                            )}

                                                            {elem?.status === -1 && (
                                                                <Typography sx={{
                                                                    fontSize: '14px',
                                                                    fontWeight: '600',
                                                                    fontFamily: "Outfit",
                                                                    color: '#000'
                                                                }}>Reject Reason : <span style={{
                                                                    fontSize: '13px',
                                                                    fontWeight: '500',
                                                                    fontFamily: "Outfit",
                                                                    color: 'red'
                                                                }}>{elem?.reject_reason}</span></Typography>
                                                            )}

                                                            {elem?.status === 0 && <Box sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'flex-end',
                                                                gap: '10px',
                                                            }}>
                                                                <Tooltip title="Approve Request">
                                                                    <IconButton
                                                                        sx={{
                                                                            background: "#4caf50",
                                                                            width: "30px",
                                                                            height: "30px",
                                                                            borderRadius: "4px",
                                                                            "&:hover": { background: "#388e3c" },
                                                                        }}
                                                                        onClick={() => {
                                                                            handleInterPreterAccountStatusChange(elem?.id, 1);
                                                                            setShowSelectedLanguageId(elem?.id);
                                                                        }}
                                                                    >
                                                                        <CheckIcon sx={{ color: "#fff" }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Reject Request">
                                                                    <IconButton
                                                                        sx={{
                                                                            background: "red",
                                                                            "&:hover": { background: "#c62828" },
                                                                            width: "30px",
                                                                            height: "30px",
                                                                            borderRadius: "4px",
                                                                        }}
                                                                        onClick={() => { handleInterPreterAccountRejectModel(elem?.id, -1) }}
                                                                    >
                                                                        <CloseIcon sx={{ color: "#fff" }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Box>}
                                                            <Box sx={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'flex-end',
                                                                gridGap: '10px',
                                                                marginTop: '10px'
                                                            }}>
                                                                <Button sx={{
                                                                    background: "rgba(0, 151, 178, 1)",
                                                                    "&:hover": { background: "rgba(0, 151, 178, 1)" },
                                                                    fontSize: '14px',
                                                                    fontWeight: '600',
                                                                    fontFamily: "Outfit",
                                                                    color: '#fff',
                                                                    padding: '5px 10px',
                                                                    borderRadius: '5px',
                                                                    textTransform: 'capitalize'
                                                                }} onClick={() => {
                                                                    handleLanguageCommissionModel(elem);
                                                                }}>Update Language Commission</Button>
                                                            </Box>
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            )
                                        }) : <Grid item xs={12}>
                                            <Typography sx={{
                                                textAlign: 'center',
                                                padding: '10px'
                                            }}>Not available language</Typography>
                                        </Grid>}
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={10}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "rgba(0, 151, 178, 1)",
                                        fontSize: { xs: '18px', md: "22px" },
                                        fontWeight: "500",
                                        fontFamily: "Outfit",
                                    }}
                                >
                                    Agreement Details
                                </Typography>
                                <Grid container spacing={1}>
                                    {isLoading ? (
                                        Array(3).fill().map((_, index) => (
                                            <Grid item xs={12} key={index}>
                                                <Box sx={{
                                                    background: "rgba(250, 250, 250, 1)",
                                                    padding: '15px',
                                                    borderRadius: '15px',
                                                    width: '100%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                }}>
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'flex-start',
                                                        gridGap: '10px',
                                                    }}>
                                                        <Skeleton circle width={48} height={48} />
                                                        <Skeleton width={100} height={30} />
                                                    </Box>
                                                    <Skeleton width={100} height={50} />
                                                </Box>
                                            </Grid>
                                        ))
                                    ) : (
                                        interpreterDetails && interpreterDetails?.user_agreement.length > 0 ? (
                                            interpreterDetails?.user_agreement?.map((elem, index) => {
                                                return (
                                                    <Grid item xs={12} key={index}>
                                                        <Box sx={{
                                                            background: "rgba(250, 250, 250, 1)",
                                                            padding: '15px',
                                                            borderRadius: '15px',
                                                            width: '100%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                        }}>
                                                            <Box sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'flex-start',
                                                                gridGap: '10px',
                                                            }}>
                                                                <Box sx={{
                                                                    width: '48px',
                                                                    height: '48px',
                                                                }}>
                                                                    <img src={AGGREMENTICON} alt="Agreement" style={{ width: '100%' }} />
                                                                </Box>
                                                                <Typography sx={{
                                                                    fontSize: '14px',
                                                                    fontWeight: '600',
                                                                    fontFamily: "Outfit",
                                                                    color: 'rgba(8, 85, 127, 1)',
                                                                }}>
                                                                    {elem?.agreement}
                                                                </Typography>
                                                            </Box>
                                                            {elem?.user_agreement_signature ? (
                                                                <img
                                                                    src={`${Constant.BASE_URL}${elem?.user_agreement_signature}`}
                                                                    alt='signature'
                                                                    style={{
                                                                        width: '180px',
                                                                        height: '80px',
                                                                        background: 'transparent',
                                                                    }}
                                                                />
                                                            ) : "N/A"}
                                                        </Box>
                                                    </Grid>
                                                )
                                            }

                                            )
                                        ) : (
                                            <Grid item xs={12}>
                                                <Typography sx={{
                                                    textAlign: 'center',
                                                    padding: '10px',
                                                }}>
                                                    Not available agreement
                                                </Typography>
                                            </Grid>
                                        )
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <CustomRejectModel
                open={showRejectModel}
                onClose={() => setShowRejectModel(false)}
                userId={userId}
                handleOnClose={() => setShowRejectModel(false)}
                status={language_status}
                handleCloseRejectModel={handleCloseRejectModel}
                interpreterDetails={interpreterDetails}
            />
            <Dialog
                open={showLanguageModel}
                onClose={() => setShowLanguageModel(false)}
                maxWidth="sm"
                fullWidth
                sx={{
                    "& .MuiPaper-root": {
                        borderRadius: "20px",
                        padding: '20px 30px',
                        height: "auto",
                        overflow: "scroll",
                        "::-webkit-scrollbar": { width: "0px", height: '0px' },
                        display: "flex",
                        flexDirection: "column",
                    },
                    "& .MuiDialogContent-root": {
                        overflowY: "initial",
                        flexGrow: 1,
                    },
                    "& .MuiBackdrop-root": {
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    }
                }}
            >
                <form onSubmit={(e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                    return false;
                }}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Typography sx={{ fontSize: '20px', fontWeight: '500', color: '#101010', fontFamily: "Outfit" }}>
                                Update Language Percentage
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <IconButton
                                    sx={{
                                        width: '30px',
                                        height: '30px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: '#101010',
                                        borderRadius: '8px',
                                        "&:hover": { backgroundColor: '#101010', color: '#fff' }
                                    }}
                                    onClick={() => setShowLanguageModel(false)}
                                >
                                    <CloseIcon sx={{ color: '#fff', fontSize: '20px' }} />
                                </IconButton>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box sx={{ padding: '20px 0px 0px 0px', flexGrow: 1 }}>
                        <Grid container spacing={2} justifyContent={'space-between'}>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={7}>
                                        <Typography sx={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "400", textAlign: "left", fontSize: { xs: "16px", sm: "18px" }, fontFamily: "Outfit", paddingBottom: '10px' }}>
                                            Language & Rate
                                        </Typography>
                                        <Box sx={{ background: "rgba(250, 250, 250, 1)", border: "1px solid rgba(8, 85, 127, 0.2)", padding: '18px 10px', borderRadius: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography sx={{ color: "rgba(8, 85, 127, 1)", fontWeight: "400", textAlign: "left", fontSize: { xs: "16px", sm: "18px" }, fontFamily: "Outfit" }}>
                                                {editLanguageDetails?.language}
                                            </Typography>
                                            <Typography sx={{ color: "rgba(0, 0, 0, 1)", fontWeight: "400", textAlign: "left", fontSize: { xs: "16px", sm: "18px" }, fontFamily: "Outfit" }}>
                                                Hourly Rate : {editLanguageDetails?.hourly_rate}$
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={5}>
                                        <Typography sx={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "400", textAlign: "left", fontSize: { xs: "16px", sm: "18px" }, fontFamily: "Outfit", paddingBottom: '10px' }}>
                                            Enter Percentage
                                        </Typography>
                                        <input
                                            placeholder='Enter Percentage'
                                            type='number'
                                            name={`percentages`}
                                            value={formik.values.percentages}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            style={{
                                                background: "rgba(64, 196, 255, 0.1)",
                                                border: "1px solid rgba(64, 196, 255, 1)",
                                                padding: '20px 10px',
                                                borderRadius: '15px',
                                                width: '100%',
                                                fontSize: '16px',
                                                fontFamily: 'Outfit',
                                                fontWeight: '400',
                                                color: '#000',
                                                outline: 'none',
                                            }}
                                        />
                                        {formik.touched.percentages &&
                                            formik.errors.percentages && (
                                                <Typography sx={{ color: 'red', fontSize: '14px' }}>
                                                    {formik.errors.percentages}
                                                </Typography>
                                            )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box sx={{ paddingTop: '20px' }}>
                        <CustomSubmitButton
                            btnTitle="Done"
                            loading={isLoading}
                            type="submit"
                        />
                    </Box>
                </form>
            </Dialog>
            {/* === Manage Certificates === */}
            <Dialog
                open={openCertificateDialog}
                onClose={handleCloseCertificateDialog}
                maxWidth="sm"
                fullWidth
                sx={{
                    "& .MuiPaper-root": {
                        borderRadius: "20px",
                        padding: '20px 30px',
                        height: "auto",
                        overflow: "scroll",
                        "::-webkit-scrollbar": { width: "0px", height: '0px' },
                        display: "flex",
                        flexDirection: "column",
                    },
                    "& .MuiDialogContent-root": {
                        overflowY: "initial",
                        flexGrow: 1,
                    },
                    "& .MuiBackdrop-root": {
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    }
                }}
            >
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 2,
                    paddingBottom: '10px',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: '600',
                            color: '#101010',
                            fontFamily: "Outfit",
                            mb: 1
                        }}
                    >
                        Manage Certificates - {selectedLanguage?.language || "Language"}
                    </Typography>
                    <Box>
                        <IconButton
                            sx={{
                                width: '30px',
                                height: '30px',
                                backgroundColor: '#101010',
                                borderRadius: '8px',
                                "&:hover": { backgroundColor: '#101010', color: '#fff' }
                            }}
                            onClick={handleCloseCertificateDialog}
                        >
                            <CloseIcon sx={{ color: '#fff', fontSize: '20px' }} />
                        </IconButton>
                    </Box>
                </Box>

                <Grid container spacing={2}>
                    {selectedCertificates?.map((cert) => (
                        <Grid item xs={12} sm={6} key={cert?.id}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    borderRadius: "10px",
                                    padding: "16px",
                                    backgroundColor: "#fafafa",
                                }}
                            >
                                <img
                                    src={`${Constant.BASE_URL}${cert?.certificate}`}
                                    alt="certificate"
                                    style={{
                                        width: '100%',
                                        height: '150px',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        marginBottom: '12px'
                                    }}
                                />

                                {cert.status === 1 ? (
                                    <Chip label="Approved" sx={{ backgroundColor: "#E6F4EA", color: "#2E7D32", fontWeight: 500 }} />
                                ) : cert.status === -1 ? (
                                    <Chip label="Rejected" sx={{ backgroundColor: "#FFEBEE", color: "#C62828", fontWeight: 500 }} />
                                ) : cert.status === -2 ? (<Chip label="Deleted" sx={{ backgroundColor: "#FFEBEE", color: "#C62828", fontWeight: 500 }} />) : (
                                    <Box display="flex" gap={1}>
                                        <Tooltip title="Approve">
                                            <IconButton
                                                sx={{ background: "#4caf50", "&:hover": { background: "#388e3c" } }}
                                                onClick={() => handleCertificateApproval(cert.id, 1)}
                                            >
                                                <CheckIcon sx={{ color: "#fff" }} />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Reject">
                                            <IconButton
                                                sx={{ background: "red", "&:hover": { background: "#c62828" } }}
                                                onClick={() => handleCertificateApproval(cert.id, -1)}
                                            >
                                                <CloseIcon sx={{ color: "#fff" }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Dialog>
        </Fragment>
    );
};

export default IntrepreterBasicDetails;